import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import MuiList from "@mui/material/List";
var StyledComponent = styled(function (props) {
    var id = props.id, children = props.children, dense = props.dense, disablePadding = props.disablePadding;
    return (_jsx(MuiList, { id: id, dense: dense, disablePadding: disablePadding, children: children }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
